import { computed, Injectable, signal } from '@angular/core';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';
import { nlSearchResoponse } from '../hire-search/hire-search.component';


@Injectable({
  providedIn: 'root',
})
export class FilterStoreService {
  private filters = signal<FilterParams>({} as FilterParams);
  screeningCriteria = signal<any>({} as any);
  criteriaMap = signal<any>({} as any);

setFilter(filters: Partial<FilterParams>) {
  this.filters.update(f => ({ ...f, ...filters })); // ✅ single atomic update, multiple fields at once
}

  getFilters(): FilterParams {
    return this.filters();
  }

  // filter-store.service.ts

activeFilterCount = computed(() => {
  const f = this.filters();
  let count = 0;
  // Boolean Search
  if (f.booleanquery && f.booleanquery !== '*')     count++;

  // Role & Experience
  if (f.jobTitleSelectedList?.length)               count++;
  if (f.pastJobTitleSelectedList?.length)           count++;
  if (f.seniority?.length)                         count++;
  if ((f.yearsofexperienceFrom != null && f.yearsofexperienceFrom !== '' && f.yearsofexperienceFrom != 0) ||  (f.yearsofexperienceTo != null && f.yearsofexperienceTo !== '' && f.yearsofexperienceTo?.length))     count++;
  if ((f.currentfromyearsofexperience != null && f.currentfromyearsofexperience !== '') ||  (f.currentfromyearsofexperience != null && f.currentfromyearsofexperience !== '' && f.currentfromyearsofexperience?.length)) count++;

  // Company
  if (f.companySelectedList?.length)               count++;
  if (f.companysize?.length)           count++;
  if (f.industrySelectedList?.length)              count++;

  // Skills & Expertise
  if (f.skillsSelectedList?.length)               count++;
  if (f.functionSelectedList?.length)             count++;

  // Location
  if (f.locationSelectedList?.length)             count++;

  // Education
  if (f.educationSelectedList?.length)            count++;
  if (f.schoolSelectedList?.length)               count++;
  if (f.fieldOfStudySelectedList?.length)         count++;
  if (f.schoolLocationSelectedList?.length)       count++;
  if (f.fromgraduationyear)                       count++;
  if (f.tograduationyear)                         count++;

  // Profile / Identity
  if (f.fullNameSelectedList?.length)             count++;
  if (f.gender && f.gender !== 'All')             count++;

  // Power Filters
  if (f.profilehighlights?.length)               count++;
  if (f.positionhierarchy?.length)               count++;

  return count;
});

clearAll() {
  this.filters.set({} as FilterParams);

}

  clearFilter() {
    this.filters.set({} as FilterParams);
  }


}
